import { EmptyState, ErrorBlock, IdleState, LoadingRow } from './StatusStates';
import { PlanSection } from './PlanSection';
import { WarningList } from './WarningList';
import type { SyntaxPanelProps } from './types';

// Body of the Syntax tab: per-floor-plan fix sections plus advisory warnings.
export const SyntaxPanel = ({
  loading,
  loaded,
  error,
  groups,
  warnings,
  acceptedRowKeys,
  editedTargets,
  onToggleRow,
  onEditTarget,
  onRetry,
}: SyntaxPanelProps) => {
  const idle = !loading && !loaded;
  const isEmpty = loaded && !loading && !error && groups.length === 0 && warnings.length === 0;
  return (
    <>
      {idle && <IdleState />}
      {loading && <LoadingRow label="Checking names…" />}
      {error && <ErrorBlock message={error} onRetry={onRetry} />}
      {isEmpty && <EmptyState message="Everything looks good ✓" />}
      {groups.map((group) => (
        <PlanSection
          key={group.file}
          group={group}
          acceptedRowKeys={acceptedRowKeys}
          editedTargets={editedTargets}
          onToggleRow={onToggleRow}
          onEditTarget={onEditTarget}
        />
      ))}
      <WarningList warnings={warnings} />
    </>
  );
};
